module.exports = __webpack_public_path__ + "img/link1.bc5e11e0.svg";